export async function processHTMLContent(url) {
  try {
    // Verificar si es un PDF
    if (url.toLowerCase().endsWith('.pdf')) {
      return {
        type: 'pdf',
        url: url,
        title: url.split('/').pop().replace('.pdf', ''),
        isPDF: true
      };
    }

    // Procesar HTML
    const response = await fetch(url);
    const html = await response.text();
    
    // Crear un elemento temporal para parsear el HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    // Extraer el contenido principal
    const mainContent = extractMainContent(tempDiv);
    
    // Buscar la tabla principal si existe
    const mainTable = tempDiv.querySelector('table[bordercolor="#cc99ff"]');
    
    return {
      type: 'html',
      title: tempDiv.querySelector('title')?.textContent || '',
      mainContent: mainContent,
      tableContent: mainTable?.innerHTML || '',
      styles: extractStyles(tempDiv),
      isPDF: false
    };
  } catch (error) {
    console.error('Error procesando el contenido:', error);
    return null;
  }
}

function extractMainContent(doc) {
  console.log('=== DEBUG: Iniciando extractMainContent ===');
  
  // Buscar específicamente las secciones con contenido
  const contentSections = [];
  
  // Buscar elementos con IDs específicos (gijon, asturiano, etc.)
  const sectionsWithIds = doc.querySelectorAll('[id]');
  console.log('Elementos con IDs encontrados:', sectionsWithIds.length);
  
  sectionsWithIds.forEach(section => {
    console.log('ID encontrado:', section.id);
    if (section.id && section.innerHTML) {
      // Buscar la fila de tabla que contiene este elemento
      let sectionRow = section.closest('tr');
      if (!sectionRow) {
        // Si no encuentra la fila, buscar el elemento padre que sea td
        sectionRow = section.closest('td');
      }
      
      if (sectionRow) {
        let sectionContent = sectionRow.innerHTML;
        
        // Limpiar el contenido
        sectionContent = sectionContent
          .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
          .replace(/<!--[\s\S]*?-->/g, '')
          .trim();
        
        console.log('Contenido de sección', section.id, ':', sectionContent.substring(0, 200) + '...');
        
        if (sectionContent) {
          contentSections.push(sectionContent);
        }
      }
    }
  });

  // Si encontramos secciones específicas, devolverlas
  if (contentSections.length > 0) {
    console.log('Devolviendo contenido de secciones específicas');
    return contentSections.join('\n');
  }

  console.log('No se encontraron secciones específicas, usando fallback');
  
  // Fallback: buscar solo el contenido de las secciones específicas, no todo el contenido
  const specificContent = [];
  
  // Buscar específicamente las secciones de Gijón y Asturiano
  const gijonSection = doc.querySelector('#gijon');
  const asturianoSection = doc.querySelector('#asturiano');
  
  if (gijonSection) {
    let gijonContent = gijonSection.closest('tr')?.innerHTML || gijonSection.innerHTML;
    gijonContent = gijonContent
      .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
      .replace(/<!--[\s\S]*?-->/g, '')
      .trim();
    if (gijonContent) {
      specificContent.push(gijonContent);
    }
  }
  
  if (asturianoSection) {
    let asturianoContent = asturianoSection.closest('tr')?.innerHTML || asturianoSection.innerHTML;
    asturianoContent = asturianoContent
      .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
      .replace(/<!--[\s\S]*?-->/g, '')
      .trim();
    if (asturianoContent) {
      specificContent.push(asturianoContent);
    }
  }
  
  if (specificContent.length > 0) {
    console.log('Devolviendo contenido específico de Gijón y Asturiano');
    return specificContent.join('\n');
  }

  // Último fallback: buscar contenido en orden de prioridad
  const contentSelectors = [
    'td[bgcolor="#FFFFFF"] blockquote',
    'td[valign="top"] > div[align="justify"]',
    'blockquote',
    '.Section1',
    'td[bgcolor="#FFFFFF"]',
    'td[valign="top"]'
  ];

  for (const selector of contentSelectors) {
    const elements = doc.querySelectorAll(selector);
    console.log('Buscando selector:', selector, '- elementos encontrados:', elements.length);
    
    if (elements.length > 0) {
      let content = '';
      elements.forEach((element, index) => {
        if (element.innerHTML) {
          let elementContent = element.innerHTML
            .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
            .replace(/<!--[\s\S]*?-->/g, '')
            .trim();
          if (elementContent) {
            console.log('Contenido del elemento', index, ':', elementContent.substring(0, 200) + '...');
            content += elementContent + '\n';
          }
        }
      });
      if (content.trim()) {
        console.log('Devolviendo contenido del selector:', selector);
        return content.trim();
      }
    }
  }

  console.log('Usando contenido completo del documento');
  // Si no se encuentra contenido específico, intentar obtener el contenido del div temporal
  return doc.innerHTML
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<!--[\s\S]*?-->/g, '')
    .trim();
}

function extractStyles(doc) {
  const styles = [];
  
  // Obtener todos los elementos style
  const styleElements = doc.querySelectorAll('style');
  styleElements.forEach(style => {
    let styleContent = style.textContent
      .replace(/<!--/g, '')
      .replace(/-->/g, '')
      .trim();
    if (styleContent) {
      styles.push(styleContent);
    }
  });

  return styles.join('\n');
}

export function parsePublicationsHTML(htmlContent) {
    console.log('Iniciando parseo de HTML, longitud:', htmlContent.length);
    
    // Crear un elemento temporal para parsear el HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    const publications = [];
    
    // Buscar todas las filas de tabla que contengan enlaces
    const allRows = tempDiv.querySelectorAll('tr');
    console.log('Total de filas encontradas:', allRows.length);
    
    // Buscar específicamente en la tabla principal
    const mainTable = tempDiv.querySelector('table[bordercolor="#cc99ff"]');
    if (mainTable) {
      console.log('Tabla principal encontrada');
      const tableRows = mainTable.querySelectorAll('tr');
      console.log('Filas en tabla principal:', tableRows.length);
      
      tableRows.forEach((row, index) => {
        const cells = row.querySelectorAll('td');
        if (cells.length >= 2) {
          const firstCell = cells[0];
          const secondCell = cells[1];
          
          const image = firstCell.querySelector('img');
          const link = secondCell.querySelector('a');
          
          if (image && link) {
            const src = image.getAttribute('src') || '';
            if (src.includes('BD10263_') || src.includes('lista')) {
              console.log(`Fila ${index}: VÁLIDA - Imagen: ${src}, Enlace: ${link.getAttribute('href')}`);
              
              // Extraer fecha
              const dateMatch = secondCell.textContent.match(/(\d{1,2}[-/_]\d{1,2}[-/_]\d{4}|\d{1,2}[-/_]\d{4}|\d{4})/);
              let date = dateMatch ? dateMatch[1].replace(/_/g, '-') : null;
              
              // Extraer título y descripción
              let title = link.textContent.trim();
              if (date && title.includes(date)) {
                title = title.replace(date, '').replace(/^[-:.,\s]+/, '').trim();
              }
              
              const fullText = secondCell.textContent.trim();
              let description = fullText.replace(date || '', '')
                                     .replace(title, '')
                                     .replace(/^[-:.,\s]+/, '')
                                     .trim();
              
              // Crear objeto de publicación
              const publication = {
                id: `pub-${index + 1}`,
                attributes: {
                  Title: title,
                  Date: date,
                  URL: link.getAttribute('href'),
                  Description: description || null,
                }
              };
              
              publications.push(publication);
            }
          }
        }
      });
    } else {
      console.log('No se encontró la tabla principal');
    }
    
    console.log('Publicaciones parseadas:', publications.length);
    return { data: publications };
  }
  
  // Example usage:
  /*
  const result = parsePublicationsHTML(htmlContent);
  console.log(JSON.stringify(result, null, 2));
  */